module.exports = __webpack_public_path__ + "88bd3dd6063e30c2e49221213354d84f.jpg";